import React from 'react';
import { Button } from '@heroui/react';
import wechatSendIcon from '@/assets/images/icons/wechat-send.svg';
import wechatShareIcon from '@/assets/images/icons/wechat-share.svg';
import wechatAddStarIcon from '@/assets/images/icons/wechat-add-star.svg';
import wechatCollectIcon from '@/assets/images/icons/wechat-collect.svg';

export type WechatActionType = 'send' | 'share' | 'add-star' | 'collect';

interface WechatActionItem {
  key: WechatActionType;
  label: string;
  icon: string;
}

export interface WechatActionProps {
  className?: string;
  onAction?: (action: WechatActionType) => void;
}

const ACTION_ITEMS: WechatActionItem[] = [
  { key: 'send', label: '转发给朋友', icon: wechatSendIcon },
  { key: 'share', label: '分享到朋友圈', icon: wechatShareIcon },
  { key: 'add-star', label: '星标', icon: wechatAddStarIcon },
  { key: 'collect', label: '收藏', icon: wechatCollectIcon },
];

export function WechatAction({ className, onAction }: WechatActionProps) {
  const handleAction = (action: WechatActionType) => {
    if (onAction) {
      onAction(action);
      return;
    }
    console.log(action);
  };

  return (
    <div
      className={className}
      style={{
        background: 'var(--background)',
        color: 'var(--foreground)',
      }}
    >
      <div className="flex items-start justify-between gap-3 p-3">
        {ACTION_ITEMS.map((item) => (
          <div key={item.key} className="flex min-w-0 flex-1 flex-col items-center gap-1">
            <Button
              isIconOnly
              variant="outline"
              aria-label={item.label}
              className="bg-background"
              onPress={() => handleAction(item.key)}
            >
              <img src={item.icon} alt="" className="h-5 w-5 object-contain" />
            </Button>
            <span className="text-center text-xs text-default-500">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
